import RelatedZGO from './RelatedZGO'

export default RelatedZGO
